var render = function render(){var _vm=this,_c=_vm._self._c;return _c('A11yDropdown',{attrs:{"dropdown-props":{
    class:'inline-block',
    ref:'dropdown'
  },"button-props":{
    class:'btn btn-default dropdown-toggle',
    type:'button',
    'aria-haspopup':'listbox',
    role:'combobox',
    'aria-controls':this.resource +'-subject-dropdown',
    id:this.resource+'-subject-dropdown-button',
    'data-role':'trigger',
    'aria-label': `${this.resource === 'presentlevel' ? 'Present Levels' : this.resource} - ${this.label}`
  },"dom-attributes":{
    role:'listbox',
    id: this.resource + '-subject-dropdown',
    'aria-labelledby':this.resource + '-subject-dropdown-button'
  }}},[_c('template',{slot:"button-contents"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('template',{slot:"dropdown-items"},_vm._l((_vm.subjects),function(subject){return _c('li',{key:subject,on:{"click":function($event){return _vm.setFilter(subject)}}},[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();}}},[_vm._v(_vm._s(subject))])])}),0)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }